import React from 'react'
import Error from 'next/error'
import { api } from 'utils'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import { JsonLd } from 'react-components/atoms'
import MetaSeo from 'components/atomic/MetaSeo'
import { PAGINEDETAIL, FORMAZIONECORSI, SLUG } from 'utils/endpoint'
import FormazioneCorsoCard from 'react-components/molecules/FormazioneCorsoCard/FormazioneCorsoCard'
import ListingCorsoFormazioneModuli from 'react-components/organisms/ListingCorsoFormazioneModuli/ListingCorsoFormazioneModuli'

const CorsoFormazioneDetail = ({ page, statusCode, corsoFormazione }) => {
  if (!page || !corsoFormazione) return <Error statusCode={statusCode} />

  return (
    <>
      <MetaSeo seo={page.seo} />
      <JsonLd item={corsoFormazione} type="corso" />
      <main
        className="formazione-corsi-page"
        style={{ backgroundColor: corsoFormazione.theme_color || '#ED740B' }}
      >
        <div className="w-container-fluid u-background-image formazione-corsi-page__top">
          <div className="w-container">
            <Breadcrumbs breadcrumbs={page.breadcrumbs} />
          </div>

          <div className="formazione-corsi-page__header">
            <div className="w-container">
              <FormazioneCorsoCard item={corsoFormazione} imageInside={true} inDetail />
            </div>
          </div>
        </div>
        <div className="formazione-page__content u-bg-white formazione-page__content--in-corso">
          <ListingCorsoFormazioneModuli
            moduli={corsoFormazione.moduli_in_corso}
            titolo={'Moduli in corso'}
          />
        </div>
        <div className="formazione-page__content u-bg-white">
          <ListingCorsoFormazioneModuli
            moduli={corsoFormazione.moduli_conclusi}
            titolo={'Moduli conclusi'}
            sottotitolo={
              'Visualizza i singoli moduli per rivedere i video, scaricare contenuti correlati e ottenere il certificato di partecipazione.'
            }
          />
        </div>
      </main>
    </>
  )
}

// export async function getStaticPaths() {
//   const response = await api.get(FORMAZIONECORSI)
//   const corsi = response.data

//   const paths = corsi
//     .map(d => ({
//       params: { slug: d.slug },
//     }))
//     .slice(0, 5)

//   return {
//     paths,
//     fallback: 'blocking',
//   }
// }

export const getServerSideProps = async ({ query, req, res }) => {
  const headers = req?.headers?.cookie
    ? { cookie: req.headers.cookie, anteprima: req.headers.anteprima || false }
    : undefined

  try {
    const corsoFormazioneResponse = await api.get(`${FORMAZIONECORSI}${SLUG}${query.slug}/`, {
      headers,
    })
    const corsoFormazione = await corsoFormazioneResponse.data

    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'formazione-corsi-detail',
        content_type_id: corsoFormazione.model,
        object_id: corsoFormazione.id,
      },
    })
    const page = await pageResponse.data

    const toolbarProps = { toolbarPage: page, toolbarItem: corsoFormazione }

    return {
      props: { page, ...toolbarProps, corsoFormazione },
      // revalidate: 1
    }
  } catch (error) {
    console.log(error)
    if (res) {
      res.statusCode = 404
    }
    return { props: { statusCode: 404 } }
  }
}

export default CorsoFormazioneDetail
